import React, { forwardRef } from 'react';
import { BoxProps } from './Box.types';

/**
 *
 * Box component.
 *
 * Serves as a wrapper component, similar to a div.
 *
 * <h2>When to use</h2>
 * Basically any time you would use a div, use this instead. It fits a react-based approach where we are
 * using components instead of raw html for pretty much everything.
 *
 * Inspired by MUI's Box Component, but without the specific styling props
 *
 *
 * <h3>Where it's used</h3>
 * * everywhere
 *
 * <h2>Usage</h2>
 *
 * <h3>Features</h3>
 * * Takes children
 * * Passes extra props
 *
 * <h3>Props</h3>
 * * children - The content of the box
 *
 * Extra props are passed to the div. e.g. onClick
 *
 *
 * <h3>Examples</h3>
 *
 * ```<Box style={{padding: '16px'}}>Hello world</Box>```
 *
 *
 *
 *<h3>.</h3>
 *<h3>.</h3>
 *<h3>.</h3>
 * <h3>(ignore this part, trying to get prop docs working)</h3>
 *
 * @property children - The content of the box 1
 *
 * @param {React.ReactNode} children - The content of the box 2
 *
 * @property ...
 *
 * @typedef BoxProps
 *
 * @todo none
 */
export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ children = null, ...props }, ref): JSX.Element => {
    return (
      <div ref={ref} {...props}>
        <>{children}</>
      </div>
    );
  },
);
